import { UrlParams } from 'framework/routing';
import { useParams } from 'react-router-dom';

export const EXTERNAL_FORM_ID = 'formId';
export const EXTERNAL_FORMS_PATH = '/external-forms';

export const useExternalFormId = () => {
  const urlParams: UrlParams = useParams<Dictionary<string>>();

  return urlParams[EXTERNAL_FORM_ID];
};
